import AddIcon from "@material-ui/icons/Add"
import RemoveIcon from "@material-ui/icons/Remove"
import React from "react"
import { useTheme } from "@material-ui/core/styles"
import { Button } from "@material-ui/core"

export default function CustomFormRowTitle({ collapse, setCollapse, text, handleSeeButton, showMore }) {

    const { theme: { bgColors, colors } } = useTheme()

    return (
        <div style={{ backgroundColor: bgColors.bgPrimary500 }} className='d-flex align-items-center justify-content-between pr-4'>
            <div className={`d-flex align-items-center`}>
                <h4 style={{
                    color: colors.colorPrimary0, margin: "5px 10px", borderRadius: '6px 6px 0 0', height: 46, fontWeight: 600, fontSize: collapse ? 20 : 15, display: 'flex', alignItems: 'center', padding: '0 27px'
                }}>{text}</h4>
            </div>
            <div className={`d-flex align-items-center`}>
                <div>
                    {collapse && <Button variant={"contained"} onClick={(e) => handleSeeButton(e)} color={"primary"} style={{ backgroundColor: bgColors.bgBlue1000, color: colors.colorPrimary0, fontSize: '12px', padding: '2px 10px', minWidth: 80, fontWeight: "bold" }}> {showMore ? "See Less" : "See More"}</Button>}
                    <button className={`ml-2 p-0`} onClick={(e) => {
                        e.preventDefault()
                        setCollapse(!collapse)
                    }}>
                        {!collapse ? <AddIcon style={{ fill: "white" }} fontSize="small" /> :
                            <RemoveIcon style={{ fill: "white" }} fontSize="small" />}
                    </button>
                </div>


            </div>
        </div>

    )
}
